export function createApiError(error, fallbackMessage = "Erro ao se comunicar com o servidor.") {
  const status = error?.response?.status || 500;
  const data = error?.response?.data || {};

  const message =
    data.message ||
    data.error ||
    error?.message ||
    fallbackMessage;

  const type =
    data.type ||
    (status >= 500 ? "failure" : status >= 400 ? "warning" : "info");

  const apiError = new Error(message);
  apiError.type = type;
  apiError.status = status;

  return apiError;
}

